import { LocalStorageService } from 'services/localStorage/localStorage';
import { logError } from 'services/logging/logging';
import { GenericError } from 'support/helpers/errors/errors';

export enum ConfirmationModalIds {
  ReviewApprovalConfirmation = 'review-approval-confirmation',
  SubmitToErpConfirmation = 'submit-to-erp-confirmation',
}

const LOCAL_STORAGE_KEY = 'hidden-confirmation-modals';

export const isForeverHiddenConfirmationModal = (id: ConfirmationModalIds, userId: string) => {
  let hiddenModals = { [id]: { [userId]: false } };
  const rawValue = LocalStorageService.getItem(LOCAL_STORAGE_KEY);
  try {
    hiddenModals = JSON.parse(rawValue || '{}');
  } catch (error) {
    logError(
      new GenericError('Failed to parse hidden-confirmation-modals from localStorage', {
        key: LOCAL_STORAGE_KEY,
        rawValue,
        originalError: error,
      }),
    );
  }
  return hiddenModals[id]?.[userId] === true;
};

export const setConfirmationModalHiddenForever = (id: ConfirmationModalIds, userId: string) => {
  let hiddenModals = { [id]: {} };
  const rawValue = LocalStorageService.getItem(LOCAL_STORAGE_KEY);
  try {
    hiddenModals = JSON.parse(rawValue || '{}');
  } catch (error) {
    logError(
      new GenericError('Failed to parse hidden-confirmation-modals from localStorage', {
        key: LOCAL_STORAGE_KEY,
        rawValue,
        originalError: error,
      }),
    );
  }
  hiddenModals[id] = {
    ...hiddenModals[id],
    [userId]: true,
  };
  LocalStorageService.setItem(LOCAL_STORAGE_KEY, JSON.stringify(hiddenModals));
};
